import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NbAutocompleteModule,
  NbButtonModule,
  NbFormFieldModule,
  NbIconModule,
  NbListModule,
  NbAccordionModule,
  NbInputModule,
  NbPopoverModule,
  NbSelectModule,
  NbSpinnerModule,
  NbProgressBarModule,
  NbTooltipModule,
  NbContextMenuModule,
  NbCardModule,
  NbUserModule,
  NbDatepickerModule,
} from "@nebular/theme";
import { ChatComponent } from "../../chat/chat.component";
import { MentionModule } from "angular-mentions";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { NgxEchartsModule } from "ngx-echarts";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatMenuModule } from "@angular/material/menu";
import { NgScormPlayerModule } from "ng-scorm-player";
import { SearchPersonComponent } from "./ui/search-person/search-person.component";
import { SkillPassportViewerComponent } from "./ui/skill-passport-viewer/skill-passport-viewer.component";
import { StudentBadgesCertificationsListingComponent } from "./ui/student-badges-certifications-listing/student-badges-certifications-listing.component";
import { NotificationItemComponent } from "./ui/notification-item/notification-item.component";
import { EmptyListIndicatorComponent } from "./ui/empty-list-indicator/empty-list-indicator.component";
import { ChatHeaderComponent } from "./ui/chat-header/chat-header.component";
import { AgEditButtonComponent } from "./ui/ag-edit-button/ag-edit-button.component";
import { AgDeleteButtonComponent } from "./ui/ag-delete-button/ag-delete-button.component";
import { AgUserPictureComponent } from "./ui/ag-user-picture/ag-user-picture.component";
import { AgArchiveDateComponent } from "./ui/ag-archive-date/ag-archive-date.component";
import { AgDateComponent } from "./ui/ag-date/ag-date.component";
import { ResourceViewerComponent } from "./ui/resource-viewer/resource-viewer.component";
import { SafePipe } from "./data-access/pipes/safe-pipe.pipe";
import { AgArchiveButtonComponent } from "./ui/ag-archive-button/ag-archive-button.component";
import { AgUnarchiveButtonComponent } from "./ui/ag-unarchive-button/ag-unarchive-button.component";
import { AgDetailButtonComponent } from "./ui/ag-detail-button/ag-detail-button.component";
import { CounterCardComponent } from "./ui/counter-card/counter-card.component";
import { CircularProgressComponent } from "./ui/circular-progress/circular-progress.component";
import { StudentEvaluationTraceComponent } from "./ui/student-evaluation-trace/student-evaluation-trace.component";
import { StarsComponent } from "./ui/stars/stars.component";
import { EmptyPageIndicatorComponent } from "./ui/empty-page-indicator/empty-page-indicator.component";
import { FullNamePipe } from "./ui/pipes/full-name.pipe";
import { StarPipe } from "./ui/pipes/star.pipe";
import { ActivityClassPipe } from "./ui/pipes/activity-class.pipe";
import { StatusLabel } from "./ui/pipes/status-label.pipe";
import { ResourceTypeIconPipe } from "./ui/pipes/resource-type-icon.pipe";
import { AgePipe } from "./ui/pipes/age.pipe";
import { ProfilePicturePipe } from "./ui/pipes/profile-picture.pipe";
import { SlicePipe } from "./ui/pipes/slice.pipe";
import { FileUrlPipe } from "./ui/pipes/file-url.pipe";
import { AssignmentColorPipe } from "./ui/pipes/assignment-color.pipe";
import { FileIconPipe } from "./ui/pipes/file-icon.pipe";
import { ActivityImagePipe } from "./ui/pipes/activity-image.pipe";
import { FrameworkPresentationComponent } from "./ui/framework-presentation/framework-presentation.component";
import { JustificationFormComponent } from "./ui/justification-form/justification-form.component";
import { JustificationPopupComponent } from "./ui/justification-popup/justification-popup.component";
import { SessionPlanningFilterComponent } from "./ui/session-planning-filter/session-planning-filter.component";
import { SelectSessionPopupComponent } from "./ui/select-session-popup/select-session-popup.component";
import { SessionsFormControlComponent } from "./ui/sessions-form-control/sessions-form-control.component";
import { StringSlicePipe } from "./ui/pipes/string-slice.pipe";
import { AgTableWrapperComponent } from "./ui/ag-table-wrapper/ag-table-wrapper.component";
import { CreateReplayComponent } from "./ui/create-replay/create-replay.component";
import { EventReplaysComponent } from "./ui/event-replays/event-replays.component";
import { HrefPipe } from "./ui/pipes/href.pipe";
import { CohortsSearchComponent } from "./ui/cohorts-search/cohorts-search.component";
import { EvaluationFieldComponent } from "./ui/evaluation-field/evaluation-field.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
@NgModule({
  // imports: [
  //   CommonModule,
  //   NbTooltipModule,
  //   DragDropModule,
  //   NbAccordionModule,
  //   NbIconModule,
  //   FormsModule,
  //   NbInputModule,
  //   NbContextMenuModule,
  //   MatMenuModule,
  //   NbPopoverModule,
  //   NbSelectModule,
  //   NbListModule,
  //   NbButtonModule,
  //   TranslatePipe,
  //   NbSpinnerModule,
  //   NbProgressBarModule,
  //   NbFormFieldModule,
  //   NbAutocompleteModule,
  //   NbCardModule,
  //   // NgxEchartsModule,
  //   NbUserModule,
  //   ReactiveFormsModule,
  //   MentionModule,
  //   NbDatepickerModule,
  //   NgScormPlayerModule.forChild({ debug: true }),
  // ],
  // exports: [
  //   EvaluationFieldComponent,
  //   SearchPersonComponent,
  //   SkillPassportViewerComponent,
  //   StudentBadgesCertificationsListingComponent,
  //   NotificationItemComponent,
  //   EmptyListIndicatorComponent,
  //   ChatComponent,
  //   ChatHeaderComponent,
  //   AgDeleteButtonComponent,
  //   AgEditButtonComponent,
  //   AgUserPictureComponent,
  //   AgArchiveDateComponent,
  //   AgDateComponent,
  //   ResourceViewerComponent,
  //   SafePipe,
  //   CounterCardComponent,
  //   CircularProgressComponent,
  //   StudentEvaluationTraceComponent,
  //   StarsComponent,
  //   EmptyPageIndicatorComponent,
  //   FullNamePipe,
  //   NbUserModule,
  //   StarsComponent,
  //   ActivityClassPipe,
  //   StarPipe,
  //   StatusLabel,
  //   AgePipe,
  //   ProfilePicturePipe,
  //   FileUrlPipe,
  //   ActivityImagePipe,
  //   AssignmentColorPipe,
  //   FileIconPipe,
  //   JustificationFormComponent,
  //   SelectSessionPopupComponent,
  //   SessionsFormControlComponent,
  //   SessionPlanningFilterComponent,
  //   StringSlicePipe,
  //   AgTableWrapperComponent,
  //   CreateReplayComponent,
  //   EventReplaysComponent,
  //   HrefPipe,
  // ],
})
export class SharedModule {}
